export enum PortalType {
  Any,
  Designer,
  AgriculturalLandUseRequest
}
